/* Auto Generated */

export enum GetMicrosoftSubscriptionsSubscriptionStatusDTO {
    none = 0,
    active = 1,
    suspended = 2,
    deleted = 3,
}
